export function formatActiveProfile(customer) {
  const {
    business_entity,
    business_email,
    business_registration_completed,
    email,
    first_name,
    id,
    last_name,
    profile_type,
  } = customer

  if (profile_type === "PERSONAL") {
    const avatar =
      first_name && last_name && first_name !== "" && last_name !== ""
        ? `${first_name[0]
            .trim()
            .toUpperCase()}${last_name[0].trim().toUpperCase()}`
        : null
    const name = profile_type.charAt(0) + profile_type.slice(1).toLowerCase()
    return { avatar, email, id: +id, name }
  }

  return {
    avatar: business_entity.brand_logo ? (
      <img
        alt="brand_logo"
        src={business_entity.brand_logo}
        height="42px"
        width="42px"
      />
    ) : null,
    business_info: {
      business_email,
      business_entity,
      business_registration_completed,
    },
    id: +business_entity.id,
    name: business_entity.legal_name,
  }
}
